import CircleWavyCheckIcon from "./circle-wavy-check-icon"

const width = 21
const height = 21
export default { width, height, Icon: CircleWavyCheckIcon }
